import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { Mapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";

type Props = RequireChildrenFor<{
    className?: string;
}>;

const Base = ({ className, children }: Props) => {
    const { steps } = usePaintConfiguratorContext();

    return (
        <div
            className={cn(
                "tw:flex tw:items-center tw:justify-center tw:ml-auto",
                className
            )}
        >
            <Mapped array={steps}>{children}</Mapped>
        </div>
    );
};

export { Base };
